// vee-validate
import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, min, max, confirmed } from 'vee-validate/dist/rules';
import { localize } from 'vee-validate';
import { configure } from 'vee-validate';

extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('confirmed', confirmed);

const config = {
  // インプットからフォーカスが外れたタイミングでバリデーションする（デフォルトは入力と同時）
  mode: 'lazy',
};

configure(config);

localize({
  en: {
    messages: {
      required: field => `${field}は必須です`,
      email: 'メールアドレスの形式が不正です。',
      min: (field, {length}) => `${field}は${length}文字以上で入力してください`,
      max: (field, {length}) => `${field}は${length}文字以下で入力してください`,
      confirmed: 'パスワードが一致しません'
    },
    fields: {
      agreement: {
        required: '利用規約とプライバシーポリシーに同意してください。',
      }
    }
  }
});

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);